import React from "react";
import TranslatedString from "Components/TranslatedString";
import PropTypes from "prop-types";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { formatServerErrors } from "Utils/serverFormats";
import t from "Utils/translation";
import Stepper from "Components/stepper2/Stepper";
import PersonalData from "./add_form/PersonalData.jsx";
import Expiration from "./add_form/Expiration.jsx";
import Emails from "./add_form/Emails.jsx";
import Recap from "./add_form/Recap.jsx";
import Congratulations from "Components/congratulations/Congratulations";
import { creationDelegate } from "Icons/index";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func
};

const formInitialState = {
  firstname: "",
  lastname: "",
  company: "",
  email_address: "",
  expiration: undefined,
  no_expiration: true,
  always: true
};

class DelegateNewScreen extends React.Component {
  constructor(props) {
    super(props);

    this.goToStep = this.goToStep.bind(this);
    this.backToList = this.backToList.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.setData = this.setData.bind(this);
    this.resetAndGoBack = this.resetAndGoBack.bind(this);
    this.prevStep = this.prevStep.bind(this);

    this.state = {
      currentStep: 1,
      steps: {
        1: {
          component: <PersonalData />
        },
        2: {
          component: <Expiration />
        },
        3: {
          component: <Emails />
        },
        4: {
          component: <Recap />
        },
        5: {
          component: <Congratulations />
        }
      },
      data: {}
    };
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  setData(data) {
    this.setState({ data: Object.assign({}, this.state.data, data) });
  }

  goToStep(no) {
    this.setState({ currentStep: no });
  }

  showStepNumber(no) {
    return this.state.steps[no];
  }

  returnToList() {
    this.props.history.push("/delegates");
  }

  submitForm() {
    this.props.setFormLoading();
    const api = new QboxmailApi({ useCookie: true });

    api
      .createDelegate(this.props.formData)
      .then(resp => {
        this.setData({ newDelegateCode: resp.resource_code });
        this.goToStep(5);
      })
      .catch(response => {
        formatServerErrors(response).then(errors => {
          this.props.setFormErrors(errors);
          this.props.unsetFormLoading();
        });
      });
  }

  resetAndGoBack() {
    this.props.resetForm();
    this.returnToList();
  }

  generateCongratulationsProps() {
    if (!this.state.data.newDelegateCode) {
      return {};
    }

    let fullname = this.props.formData.firstname + " " + this.props.formData.lastname;

    return {
      title: t("delegate.add.title.step5"),
      body: (
        <TranslatedString
          subs={{
            name: fullname,
            emailAddress: this.props.formData.email_address,
            userID: this.state.data.newDelegateCode
          }}
        >
          delegate.add.desc.step5
        </TranslatedString>
      ),
      illustration: creationDelegate,
      buttonText: `button.manage.delegates`,
      buttonAction: () => this.props.history.push("/delegates")
    };
  }

  backToList() {
    this.props.history.push("/delegates");
  }

  prevStep() {
    if (this.state.currentStep <= 1) return;
    this.setState({ currentStep: this.state.currentStep - 1 });
  }

  render() {
    let toShow = this.showStepNumber(this.state.currentStep);

    return (
      <div className="contentWrapper">
        {React.cloneElement(toShow.component, {
          ...this.props,
          goToStep: this.goToStep,
          submitForm: this.submitForm,
          onSuccess: () => this.onSuccess(),
          loggedUserType: this.context.getLoggedUserType(),
          isloggedUserInTrial: this.context.isLoggedUserTrial(),
          isLoggedUserAdmin: this.context.isLoggedUserAdmin(),
          hasloggedUserCatchallEnabled: !!this.context.getLoggedUser().catch_all,
          isReseller: this.context.getLoggedUser().is_reseller,
          setData: this.setData,
          data: this.state.data,
          backToList: this.backToList,
          resetAndGoBack: this.resetAndGoBack,
          stepper: <Stepper steps={4} active={this.state.currentStep} goBack={this.prevStep} />,
          ...this.generateCongratulationsProps()
        })}
      </div>
    );
  }
}

//DelegateNewScreen.propTypes = propTypes;
DelegateNewScreen.contextTypes = ContextTypes;

export default withFormState(DelegateNewScreen, formInitialState);
